




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {IRequestPromoCode, IRequestPromoCodeHistory} from "@/entities";
import OrderItemCard from './OrderItemCard.vue';
import {StatusTagType} from "@/components/lib/models";

@Component({
  components: {
    OrderItemCard
  }
})
export default class OrderPromoCodeCard extends Vue {

  @Prop() readonly data!: IRequestPromoCode
  @Prop({ default: false }) readonly showControl?: boolean
  @Prop() readonly token?: string

  private fetchHistories(): Promise<IRequestPromoCodeHistory[]> {
    return this.$storage.actions.getRequestPromoCodeHistories({
      key: this.data.id
    });
  }

  get value(): string {
    return this.$options.filters?.trim(this.data.value);
  }

  private mapStatus(status?: string): StatusTagType {
    switch (status) {
      case "used":
        return 'success'
      default:
        return 'none'
    }
  }

  get category(): string {
    const category = this.data.category;
    return this.$options.filters?.capitalize(this.$t(`category.${category}`));
  }

  get used(): boolean {
    return this.data.status === 'used';
  }

  get description(): string {
    if (this.used) {
      return this.$t('modals.cert.coupon.used') as string;
    } else {
      const body = this.$t('modals.cert.description[1]', {
        value: this.value,
        category: this.category
      });
      const start = this.showControl ? '' : (this.$t('modals.cert.description[0]') + ', ');
      return start ? (start + ' ' + body) : this.$options.filters?.capitalize(body);
    }
  }

}
